import React from 'react';
function Maximize({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.889 5H6.555C5.696 5 5 5.696 5 6.556v2.333M19 8.889V6.556C19 5.696 18.303 5 17.444 5h-2.333M15.11 19h2.334c.859 0 1.555-.697 1.555-1.556v-2.333M5 15.111v2.333C5 18.304 5.696 19 6.555 19H8.89"
      />
    </svg>
  );
}

export default Maximize;
